import React from 'react';

import { useTranslation } from 'react-i18next';

import ErrorMonkey from '@pkg/assets/images/error-monkey.png';
import { ButtonDeprecated } from '@pkg/components';
import { useAppDispatch } from '@pkg/hooks';

import { NftMintSteps } from '@app/client';
import { setNftMintPanelStep } from '@app/store/actions/nft';

import { Typography } from '../../../DesignSystem';
import '../NftSidePanel.scss';

export const Error = () => {
    const { t } = useTranslation(['nft', 'common']);
    const dispatch = useAppDispatch();

    const onClickTryAgain = () => {
        dispatch(setNftMintPanelStep(NftMintSteps.Introduction));
    };

    return (
        <div className="yat-nft-sidebar__step yat-nft-sidebar__error">
            <div className="yat-nft-sidebar__flex-item">
                <img className="yat-nft-sidebar__error-image" src={ErrorMonkey} alt={t('mint_error_title')} />
                <Typography type="headline" size={40} classes={['yat-nft-sidebar__title']}>
                    {t('mint_error_title')}
                </Typography>
                <Typography type="paragraph" size={16} classes={['yat-nft-sidebar__text']}>
                    <span>{t('mint_error_text')}</span>
                </Typography>
                <ButtonDeprecated
                    color="primary"
                    size="hero"
                    classes={['nft-sidebar-cta-desktop']}
                    onClick={onClickTryAgain}
                >
                    {t('common:try_again')}
                </ButtonDeprecated>
                <ButtonDeprecated
                    classes={['nft-sidebar-cta-mobile']}
                    color="primary"
                    fluid
                    size="large"
                    onClick={onClickTryAgain}
                >
                    {t('common:try_again')}
                </ButtonDeprecated>
            </div>
        </div>
    );
};
